import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-70568303"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src"]

import {
  IonHeader,
  IonToolbar,
  IonMenuButton,
  IonButtons,
} from '@ionic/vue';
import { usePayee } from '@/payee.composable';
import { useAuth } from '@/auth/auth.composable';


export default /*#__PURE__*/_defineComponent({
  name: 'AppHeader',
  setup(__props) {

const { payee } = usePayee();
const { isAuthenticated } = useAuth();


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonHeader), { translucent: true }, {
    default: _withCtx(() => [
      _createVNode(_unref(IonToolbar), null, {
        default: _withCtx(() => [
          (_unref(payee))
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                class: _normalizeClass([{'logged-in': _unref(isAuthenticated)}, "header-icon"]),
                src: `data:image/${_unref(payee)?.logoFileType === 'png' ? 'png' : 'svg+xml'};base64, ` + _unref(payee)?.logoBase64
              }, null, 10, _hoisted_1))
            : _createCommentVNode("", true),
          (_unref(isAuthenticated))
            ? (_openBlock(), _createBlock(_unref(IonButtons), {
                key: 1,
                slot: "end"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonMenuButton))
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})